module.exports = __webpack_public_path__ + "img/ícone-menu-lateral.2427ed12.svg";